export const getStandardDateFormat = (startTime: Date): string => {
    return new Date(startTime).toString().replace(/GMT.*$/, '').trim();
}